
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ControlMixin extends Vue {
  protected focusInput(ref: string) {
    this.$nextTick(() => (this.$refs[ref] as any).focus())
  }
}
